import { allowSnapType } from '@ps/types/workbench/stage.type'
import StageData from '@ps/store/workbench/stage/stage-data'
import { allowSnap } from '@ps/store/workbench/stage/config/snap-config'
import { isVirtualNode } from '@ps/store/workbench/stage/config/layer-config'
import Konva from 'konva'
import nodePool from '@ps/bridge/qc/node-pool'
import { moveNodeByShape } from '@ps/store/workbench/stage/utils/helper'
import {
  drawGuides,
  getGroupSnappingEdges,
  getGuides,
  getLineGuideStops,
  getObjectSnappingEdges,
  removeGuides,
} from '@ps/store/workbench/stage/snap'

export default {
  addLayerSnappingEvent(): void {
    const layer = StageData.layer!
    layer.on('dragmove', function (e) {
      // 如果不允许吸附，直接返回
      if (!allowSnap(e.target)) return
      // 如果按着 shift 按键，代表横向和纵向位移，不允许吸附
      if (e.evt.shiftKey) return
      removeGuides()
      const target = e.target as allowSnapType
      // find possible snapping lines
      const lineGuideStops = getLineGuideStops(target)
      // find snapping points of current object
      const transformers = StageData.transformer!
      let itemBounds = getObjectSnappingEdges(target)
      // 如果框选了组，需要把框选的组的边界也加进来, 或者该节点含有联动节点，需要把联动节点也加进来
      if (
        transformers.nodes().length > 1 ||
        (target.attrs.dragLinkage && transformers.nodes().length === 1)
      ) {
        const group =
          transformers.nodes().length > 1 ? transformers.nodes() : []
        if (target.attrs.dragLinkage) {
          group.push(target)
          const linkageShape = layer.findOne(`#${target.attrs.dragLinkage}`)
          if (linkageShape) {
            group.push(linkageShape)
          }
        }
        itemBounds = getGroupSnappingEdges(group as allowSnapType[])
      }
      // now find where can we snap current object
      const guides = getGuides(lineGuideStops, itemBounds)

      // do nothing of no snapping
      if (!guides.length) {
        target.attrs.syncStyle = true
        return
      }
      drawGuides(guides)

      function forceShapePosition(shape: allowSnapType) {
        const absPos = shape.absolutePosition()
        // now force object position
        // 获取当前元素的支持吸附边沿与吸附指引线的偏移差异值，并设置当前元素的位置到吸附指引线上
        guides.forEach((lg) => {
          switch (lg.orientation) {
            case 'V': {
              absPos.x =
                absPos.x +
                lg.lineGuide -
                itemBounds.vertical.find((item) => item.snap === lg.snap)!.guide
              break
            }
            case 'H': {
              absPos.y =
                absPos.y +
                lg.lineGuide -
                itemBounds.horizontal.find((item) => item.snap === lg.snap)!
                  .guide
              break
            }
            default:
              break
          }
        })
        shape.absolutePosition(absPos)
        if (isVirtualNode(shape)) {
          const virtualNode = shape as Konva.Rect
          const nodeUuid = virtualNode.attrs.id
          const node = nodePool.find(nodeUuid)
          // 如果含有联动节点，代表这个节点会通过 dragmove 去移动联动节点，不能取消联动
          if (!virtualNode.attrs.dragLinkage) {
            // 取消 konva 元素跟 qc.Node 的联动
            target.attrs.syncStyle = false
          }
          moveNodeByShape({
            node: node,
            shape: virtualNode,
          })
        }
      }

      // 框选的时候, 或者该节点含有联动节点时，需要把所有相关元素的位置都偏移
      // 框选的时候，需要把框选的元素的位置都偏移
      if (transformers.nodes().length > 1) {
        // 确保该逻辑在一次 dragmove 中有且只会执行一次，避免重复执行
        if (target === transformers.nodes()[0]) {
          transformers.nodes().forEach((item) => {
            const childItem = item as Konva.Rect
            forceShapePosition(childItem)
          })
        }
      } else {
        forceShapePosition(target)
        if (target.attrs.dragLinkage) {
          const linkageShape = layer.findOne(
            `#${target.attrs.dragLinkage}`,
          ) as Konva.Rect
          if (linkageShape) {
            forceShapePosition(linkageShape)
          }
        }
      }
    })

    layer.on('dragend', function (e) {
      // 如果不允许吸附，直接返回
      if (!allowSnap(e.target)) return
      const target = e.target as allowSnapType
      target.attrs.syncStyle = true
      // clear all previous lines on the screen
      removeGuides()
    })
  },
}
